export type AttemptBackgroundJobAutoAckArgs = {
  backgroundJobId: number
  autoAckAttemptedJobIds: Set<number>
  acknowledgeBackgroundJob: (backgroundJobId: number) => Promise<void>
}

/** Acknowledges a terminal background job once when auto-dismiss rules pass. */
export const attemptBackgroundJobAutoAck = async ({
  backgroundJobId,
  autoAckAttemptedJobIds,
  acknowledgeBackgroundJob,
}: AttemptBackgroundJobAutoAckArgs): Promise<void> => {
  if (autoAckAttemptedJobIds.has(backgroundJobId)) {
    return
  }

  autoAckAttemptedJobIds.add(backgroundJobId)

  try {
    await acknowledgeBackgroundJob(backgroundJobId)
  } catch (error) {
    console.error(error)
    autoAckAttemptedJobIds.delete(backgroundJobId)
  }
}
